import {
  setStoredPhoenixClick,
  getStoredPhoenixClick,
  deleteStoredPhoenixClick,
} from "./storage";
import { PHX_CLICK_ID_QUERY_NAME } from "./constants";

interface StoredPhoenixClick {
  phxClickId: string;
}

export function clearPhoenixClickId(): void {
  deleteStoredPhoenixClick();
}

export function getPhoenixClickId(): string | null {
  const data = getStoredPhoenixClick<StoredPhoenixClick>();
  return data?.phxClickId || null;
}

export function getPhoenixClickIdFromUrl(): string | null {
  const clickId = new URL(window.location.href).searchParams.get(
    PHX_CLICK_ID_QUERY_NAME,
  );

  if (!clickId) return null;

  return clickId;
}

export function capturePhoenixClickId(): void {
  const clickId = getPhoenixClickIdFromUrl();
  if (!clickId) return;

  const existing = getPhoenixClickId();
  if (existing === clickId) return;

  setStoredPhoenixClick<StoredPhoenixClick>({
    phxClickId: clickId,
  });
}
